export const ALL_APA_STRUCTURE_TYPE_REQUEST = 'ALL_APA_STRUCTURE_TYPE_REQUEST';
export const ALL_APA_STRUCTURE_TYPE_SUCCESS = 'ALL_APA_STRUCTURE_TYPE_SUCCESS';
export const ALL_APA_STRUCTURE_TYPE_FAIL = 'ALL_APA_STRUCTURE_TYPE_FAIL';

